<template>
    <section class="app-main">
        <div class="title">
            <p @click="$router.go(-1)"><i class="el-icon-back"></i>返回礼品列表</p>
            <p>用户兑换列表</p>
        </div>
        <div class="top-bar">
            <el-input placeholder="输入手机号或邮箱" v-model="searchVal" @change="getData" style="width:240px;margin-right:30px" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-radio-group v-model="status" @change="change">
                <el-radio label="" border>全部</el-radio>
                <el-radio :label="0" border>未兑换</el-radio>
                <el-radio :label="1" border>已兑换</el-radio>
            </el-radio-group>
        </div>
        <el-card >
            <el-table :data="tableData"  height="500">
                <el-table-column prop="gift_info.title" label="礼品名称" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="pic" label="礼品图片" align="center">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.gift_info.pic" :src="scope.row.gift_info.pic" />
                    </template>
                </el-table-column>
                <el-table-column prop="" label="手机号" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.user_info.phone ? scope.row.user_info.phone : '-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="邮箱" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.user_info.email ? scope.row.user_info.email : '-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="领取时间" align="center"></el-table-column>
                <el-table-column prop="expire_type" label="有效期" align="center" width="220">
                    <template slot-scope="scope">
                        <span v-if="scope.row.gift_info.expire_type == 0">{{scope.row.gift_info.expire_item}}天</span>
                        <span v-else>截止 {{scope.row.gift_info.expire_item}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 0" style="color:red">未兑换</span>
                        <span v-else style="color:green">已兑换</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="250">
                    <template slot-scope="scope">
                        <el-button type="success" plain size="mini" @click="handleExchange(scope.row)" v-if="scope.row.status == 0">兑换</el-button> 
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </el-card>
    </section>
</template>
<script>
import { gift_detail, gift_exchange } from '@/api/market.js'
import MImg   from '@/components/Image'
export default {
    components: { MImg },
    data() {
        return {
            searchVal: '',
            tableData: [],
            table_load: false,
            total: 0,
            page: 1,
            size: 0,
            status: '',
            disabled: false,
        }
    },
    methods: {
        change() {
            this.page = 1
            this.getData()
        },
        getData() {
            let params = {
                page: this.page,
                gift_id: this.$route.query.id,
                status: this.status
            }
            if(this.searchVal != '') {
                params.keywords = this.searchVal
            }
            gift_detail(params).then(res => {
                if(res) {
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size  = res.data.per_page
                } else {
                    this.tableData = []
                    this.total = 0
                    this.size = 0
                }
            })
        },
        reloadData(page) {
            this.page = page;
            this.getData();
        },
        handleExchange(row) {
            gift_exchange(row.id, {status: 1}).then(res => {
                if(res) {
                    this.$message({type:"success", message: res.msg})
                    this.getData()
                }
            })
        }
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
section {
    .title {
        margin-left: 10px;
        p:nth-child(1) {
            width: 124px;
            text-decoration: underline;
            color: #169bff;
            margin-bottom: 10px;
            cursor: pointer;
        }
        p:nth-child(2) {
            margin-bottom: 10px;
            font-size: 26px;
            font-weight: bold;
            color: #0A1629;
        }
    }
    .top-btn {
        width: 100px;
    }
    .item-label {
        height: 40px;
        line-height: 40px;
    }
    .line-item {
        margin-top: 25px;
        &:nth-child(1){
            margin-top: 0;
        }
    }
    /deep/ .el-dialog__body {
        text-align: left
    }
}
</style>
